import $ from 'jquery';
import tmplContent from './templates/content.twig';
import Utils from 'common/scripts/utils';

class Tenders {
    constructor() {
        this.activeClass = 'is-active';
    }

    init(options) {
        this.wrapper = options.target;
        this.url = this.wrapper.dataset.action;
        this.method = this.wrapper.dataset.method;
        this.content = this.wrapper.querySelector('.j-tenders__content');
        this._initElements();
    }

    _initElements() {
        this.$buttons = $('.j-tenders__button');
        this.$buttons.each((index, button) => {
            $(button).unbind('click');
            $(button).on('click', (event) => {
                this._send(event);
            });
        });
    }

    _send(event) {
        const that = this;
        const target = event.currentTarget;
        const type = target.dataset.type;

        this.$buttons.each((index, button) => {
            const method = button === target ? 'add' : 'remove';

            button.classList[method](this.activeClass);
        });

        const dataToSend = $.param({
            type,
            page: target.dataset.page || 1
        });

        Utils.send(dataToSend, this.url, {
            success(respond) {
                const currentPage = Number(respond.data.pages.current);
                const paginationPageCount = 4;
                const interval = Math.floor(currentPage / paginationPageCount);

                Object.assign(respond.data.pages, {interval});
                Object.assign(respond.data, {type});

                Utils.clearHtml(that.content);
                that.content.insertAdjacentHTML('beforeend', tmplContent(respond.data));
                that._initElements();
            },
            error(error) {
                console.error(`Ошибка на сервере: ${error}`);
            }
        }, 'POST');
    }
}

export default Tenders;
